"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDeleteChargeChangeEventMutation = exports.useFetchChargeAuditLogQuery = exports.useFetchChargeHistoryQuery = exports.useRemoveChargeMutation = exports.useUpdateChargeMutation = exports.useFetchChargesForTenantQuery = exports.useFetchChargesByServiceIdQuery = exports.useFetchChargeQuery = exports.useFetchClientChargesQuery = exports.useCreateChargeMutation = exports.chargeApi = void 0;
// api/chargeApi.ts
var react_1 = require("@reduxjs/toolkit/query/react");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
exports.chargeApi = (0, react_1.createApi)({
    reducerPath: "chargeApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.LETS_CUE_API),
    tagTypes: ["charges"],
    endpoints: function (builder) { return ({
        createCharge: builder.mutation({
            query: function (obj) { return ({
                url: "/v1/charge/create",
                method: "POST",
                body: obj,
            }); },
            invalidatesTags: ["charges"],
        }),
        fetchClientCharges: builder.query({
            query: function (obj) { return ({
                url: "/v1/charge/all",
                method: "GET",
                params: {
                    clientId: obj.clientId,
                    serviceId: obj.serviceId,
                    chargeType: obj.chargeType,
                    page: obj.page,
                    limit: obj.limit,
                },
            }); },
            providesTags: ["charges"],
        }),
        fetchCharge: builder.query({
            query: function (chargeId) { return ({
                url: "/v1/charge/fetch",
                method: "GET",
                params: {
                    _id: chargeId,
                },
            }); },
            providesTags: ["charges"],
        }),
        fetchChargesByServiceId: builder.query({
            query: function (serviceId) { return ({
                url: "/v1/charge/by-service",
                method: "GET",
                params: {
                    serviceId: serviceId,
                },
            }); },
            providesTags: ["charges"],
        }),
        fetchChargesForTenant: builder.query({
            query: function (_a) {
                var clientId = _a.clientId, serviceId = _a.serviceId, areaId = _a.areaId;
                return ({
                    url: "/v1/charge/for-tenant",
                    method: "GET",
                    params: { clientId: clientId, serviceId: serviceId, areaId: areaId },
                });
            },
            providesTags: ["charges"],
        }),
        updateCharge: builder.mutation({
            query: function (obj) { return ({
                url: "/v1/charge/update",
                method: "PUT",
                body: obj,
            }); },
            invalidatesTags: ["charges"],
        }),
        removeCharge: builder.mutation({
            query: function (_a) {
                var chargeId = _a.chargeId, performedBy = _a.performedBy, reason = _a.reason;
                return ({
                    url: "/v1/charge/remove",
                    method: "DELETE",
                    params: __assign({ _id: chargeId, performedBy: performedBy }, (reason ? { reason: reason } : {})),
                });
            },
            invalidatesTags: ["charges"],
        }),
        fetchChargeHistory: builder.query({
            query: function (chargeId) { return ({
                url: "/v1/charge/history",
                method: "GET",
                params: { _id: chargeId },
            }); },
            providesTags: function (_result, _err, chargeId) { return [{ type: "charges", id: "history:".concat(chargeId) }]; },
        }),
        fetchChargeAuditLog: builder.query({
            query: function (_a) {
                var chargeId = _a.chargeId, action = _a.action, includeDeleted = _a.includeDeleted;
                return ({
                    url: "/v1/charge/audit-log",
                    method: "GET",
                    params: __assign(__assign({ _id: chargeId }, (action ? { action: action } : {})), (includeDeleted ? { includeDeleted: true } : {})),
                });
            },
            providesTags: function (_result, _err, arg) { return [{ type: "charges", id: "audit:".concat(arg.chargeId) }]; },
        }),
        deleteChargeChangeEvent: builder.mutation({
            query: function (_a) {
                var eventId = _a.eventId, performedBy = _a.performedBy, reason = _a.reason;
                return ({
                    url: "/v1/charge/audit-log/event",
                    method: "DELETE",
                    body: { eventId: eventId, performedBy: performedBy, reason: reason },
                });
            },
            invalidatesTags: function (_result, _err, arg) { return [
                { type: "charges", id: "audit:".concat(arg.chargeId) },
                { type: "charges", id: "history:".concat(arg.chargeId) },
            ]; },
        }),
    }); },
});
exports.useCreateChargeMutation = exports.chargeApi.useCreateChargeMutation, exports.useFetchClientChargesQuery = exports.chargeApi.useFetchClientChargesQuery, exports.useFetchChargeQuery = exports.chargeApi.useFetchChargeQuery, exports.useFetchChargesByServiceIdQuery = exports.chargeApi.useFetchChargesByServiceIdQuery, exports.useFetchChargesForTenantQuery = exports.chargeApi.useFetchChargesForTenantQuery, exports.useUpdateChargeMutation = exports.chargeApi.useUpdateChargeMutation, exports.useRemoveChargeMutation = exports.chargeApi.useRemoveChargeMutation, exports.useFetchChargeHistoryQuery = exports.chargeApi.useFetchChargeHistoryQuery, exports.useFetchChargeAuditLogQuery = exports.chargeApi.useFetchChargeAuditLogQuery, exports.useDeleteChargeChangeEventMutation = exports.chargeApi.useDeleteChargeChangeEventMutation;
